import React from "react";
import Navigation from "./Navigation";
import { BrowserRouter as Router } from "react-router-dom";
import { SnackbarProvider } from "./AlertSystem";

const ClinicianPortal = props => {
  return (
    <SnackbarProvider>
      <Navigation user={props.user} />
    </SnackbarProvider>
  );
};

export default ClinicianPortal;
